export const DOCUMENT_TYPE_SWAGGER = 'APIZRIO_SWAGGER';
export const DOCUMENT_TYPE_ASYNCAPI = 'APIZRIO_ASYNCAPI';

export function getTypeFromSpec(spec) {
  if (!spec) {
    return DOCUMENT_TYPE_SWAGGER;
  }

  return spec.asyncapi !== undefined ? DOCUMENT_TYPE_ASYNCAPI : DOCUMENT_TYPE_SWAGGER;
}
